import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content", "trigger"]

  connect() {
    this.setupEventListeners()
  }

  disconnect() {
    this.removeEventListeners()
  }

  setupEventListeners() {
    // Escape key listener
    document.addEventListener('keydown', this.handleClose.bind(this))
  }

  removeEventListeners() {
    document.removeEventListener('keydown', this.handleClose.bind(this))
  }

  handleClose(event) {
    // Handle escape key
    if (event.type === 'keydown' && event.key === 'Escape' && this.isOpen()) {
      this.close()
    }
    // Handle background click
    if (event.type === 'click' && event.target === event.currentTarget) {
      this.close()
    }
  }

  open() {
    this.showModal()
    this.lockBodyScroll()
    this.showBackground()
    this.slideInContent()
  }

  close() {
    this.slideOutContent()
    this.hideBackground()

    setTimeout(() => {
      this.hideModal()
      this.unlockBodyScroll()
    }, 1500)
  }

  showModal() {
    this.modalTarget.classList.remove('hidden')
  }

  hideModal() {
    this.modalTarget.classList.add('hidden')
  }

  showBackground() {
    this.modalTarget.classList.remove('bg-transparent')
    this.modalTarget.classList.add('bg-black', 'bg-opacity-50')
  }

  hideBackground() {
    this.modalTarget.classList.remove('bg-black', 'bg-opacity-50')
    this.modalTarget.classList.add('bg-transparent')
  }

  slideInContent() {
    this.contentTarget.style.transform = 'translateX(0)'
  }

  slideOutContent() {
    this.contentTarget.style.transform = 'translateX(100vw)'
  }

  lockBodyScroll() {
    const scrollbarWidth = this.getScrollbarWidth()
    document.body.style.overflow = 'hidden'
    document.body.style.overflowX = 'hidden'
    document.body.style.paddingRight = `${scrollbarWidth}px`
  }

  unlockBodyScroll() {
    document.body.style.overflow = ''
    document.body.style.overflowX = ''
    document.body.style.paddingRight = ''
  }

  getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth
  }

  isOpen() {
    return !this.modalTarget.classList.contains('hidden')
  }
}
